// Bounds reach the form as strings from the crop API ("0.250"), and sometimes as
// the sentinel "NA" — absent must be absent, not NaN. A genuine 0 is kept.
export const toNumber = (value) => {
  const n = parseFloat(value);
  return Number.isFinite(n) ? n : undefined;
};

export const round2dp = (n) => Number(Number(n).toFixed(2));

export const format2dp = (value) => {
  const n = value === "" || value === null || value === undefined ? NaN : Number(value);
  return Number.isFinite(n) ? String(round2dp(n)) : value;
};
